<template>
    <div>
        <div class="row q-mb-md">
            <!-- Filters hide/show button -->
            <div class="col-6">
                <div class="row" style="justify-content: flex-start">
                    <q-btn
                        @click="showFilters()"
                        :text-color="hideFilters ? 'grey-5' : 'white'"
                        class="neutral-btn ctrl-button btn-compact"
                        :class="{ primary: !hideFilters }"
                        icon="filter_list"
                        :icon-right="
                            hideFilters
                                ? 'keyboard_arrow_up'
                                : 'keyboard_arrow_down'
                        "
                    />

                    <!-- Searchfield -->
                    <div class="q-ml-md" style="flex-grow: 1">
                        <q-input
                            :disable="!hideFilters || activeFilters"
                            color="grey-5"
                            v-model="searchTerm"
                            @input="applyFilters"
                            :placeholder="
                                getString(null,
                                    'Search by etim combination description', 'Zoek op etimcombinatie omschrijving'
                                )
                            "
                        />
                    </div>
                </div>
            </div>
            <!-- Add button -->
            <div class="col-6" style="justify-content: flex-end">
                <q-btn
                    class="capitalize ctrl-button right"
                    color="ctrl-turquoise"
                    :label="getString('action.add')"
                    @click="$router.push('/etim/combination/add')"
                    icon-right="add"
                />
            </div>
        </div>

        <!-- Filters block -->
        <transition name="fade">
            <div v-if="!hideFilters" class="table-block q-mb-md">
                <div class="row q-pa-md" style="justify-content: space-between">
                    <!-- Searchfield -->
                    <div class="col-6 q-pa-md">
                        <q-input
                            color="primary"
                            v-model="filters.description"
                            @input="applyFilters"
                            :float-label="getString('description')"
                        />
                    </div>
                </div>

                <div class="row q-pa-md" style="justify-content: space-between">
                    <div class="q-pa-md" style="vertical-align: middle">
                        <q-btn
                            :disable="!activeFilters"
                            @click="resetFilters()"
                            class="capitalize ctrl-button"
                            :color="activeFilters ? 'primary' : 'grey-4'"
                            label="Reset"
                        />
                    </div>
                </div>
            </div>
        </transition>
        <table-overview
            endpoint="etim/combination"
            :responseFormat="'combinations'"
            :columns="columns"
            permission="etim"
            module="etim/combination"
            :selectable="false"
        >
        </table-overview>
    </div>
</template>

<script>
// Mixins
import filtersMixin from '@/mixins/tables/filtersMixin';
import getString from '@/helpers/GetStrings';

// Components
import TableOverview from '@/components/overview/TableOverview.vue';

export default {
  mixins: [
    filtersMixin,
  ],
  components: {
    TableOverview,
  },
  data() {
    return {
      isLoading: false,
      columns: [
        {
          name: 'description',
          title: getString('description'),
          sortField: 'description',
          titleClass: 'text-left sortable vcol-s',
          dataClass: 'text-left vcol-s user text-ellipsis',
        },
        {
          name: '__slot:etim-template',
          title: 'Template',
          sortField: 'template',
          titleClass: 'text-left sortable vcol-xl',
          dataClass: 'text-left vcol-xl user text-ellipsis',
        },
        {
          name: 'unit',
          title: 'Unit',
          sortField: 'unit',
          titleClass: 'text-left sortable vcol-xs',
          dataClass: 'text-left vcol-xs user text-ellipsis',
        },
      ],
      filters: {
        name: '',
      },
      searchTerm: '',
      hideFilters: true,
    };
  },
  methods: {
    getString,
  },
};
</script>
